import styled from "styled-components";
import { useEffect, useState } from "react";
import { AiOutlineCompass } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { selectUser, logout } from "../../features/userSlice";
import { auth } from "../../config/firebase.config";
import { Link, useHistory } from "react-router-dom";
import { subscribeCommunities } from "../../utils/communities";
import { useVerified } from "../../context/VerifiedContext";
import { VerificationBadge } from "../common/VerificationBadge";
import { RequestVerification } from "../common/RequestVerification";

export const CreateSpace = () => {
    const user = useSelector(selectUser);
    const dispatch = useDispatch();
    const history = useHistory();
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const [joined, setJoined] = useState([]);
    const { isVerified, getBadgeType, isSuperAdmin } = useVerified();
    const [showVerifyModal, setShowVerifyModal] = useState(false);


    useEffect(() => {
        const unsub = subscribeCommunities((list) => {
            const member = list.filter((c) =>
                (c.members || []).includes(user?.uid)
            );
            setJoined(member);
        });
        return unsub;
    }, [user?.uid]);

    const handleSignOut = () => {
        auth.signOut();
        dispatch(logout());
    };

    const usernameHandle = user?.email ? `@${user.email.split("@")[0]}` : "@felix";

    return (
        <>
        <Space>
            <div className="create-space-container">
                <div
                    className="createSpace"
                    onClick={() => history.push("/home?createcommunity=1")}
                >
                    <div>
                        <div>+</div>
                    </div>
                    <p>Create Community</p>
                </div>
                <div className="create-space-content"></div>

                <div className="my-communities">
                    <span className="label">My Communities</span>
                    {joined.length === 0 && (
                        <div className="none">Join communities to see them here.</div>
                    )}
                    {joined.slice(0, 10).map((c) => (
                        <Link key={c.id} to={`/c/${c.slug}`} className="my-comm">
                            {c.avatar ? (
                                <img src={c.avatar} alt="" />
                            ) : (
                                <span className="init">{(c.name || "C").charAt(0).toUpperCase()}</span>
                            )}
                            <span>{c.name}</span>
                        </Link>
                    ))}
                </div>

                <Link to="/fellows" style={{ textDecoration: "none" }}>
                    <div className="discoverSpace">
                        <span>
                            <AiOutlineCompass className="compass" />
                        </span>
                        <p>Discover Fellows</p>
                    </div>
                </Link>

                {/* 👥 Fellows Online Sidebar Card */}
                <FellowsCard>
                    <div className="card-header">
                        <div className="icon-badge">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                            </svg>
                        </div>
                        <strong>Fellows Online</strong>
                    </div>
                    <div className="online-count">
                        <span className="live-pulse" />
                        <span>128 Fellows online</span>
                    </div>
                    <p>Meet new people from your university & faculty.</p>
                    <Link to="/fellows">
                        <button className="discover-btn">
                            <span>Discover Fellows</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                <path d="M5 12h14M12 5l7 7-7 7"/>
                            </svg>
                        </button>
                    </Link>
                </FellowsCard>

                {/* 👤 User Profile Card at Bottom of Sidebar */}
                <UserProfileCard>
                    <div
                        className="user-profile-header"
                        onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                    >
                        <div className="avatar-ring">
                            <img
                                src={
                                    user?.photoURL ||
                                    "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80"
                                }
                                alt="User Profile"
                            />
                            <span className="online-badge" />
                        </div>
                        <div className="user-info">
                            <h4>
                                {user?.displayName || "Felix Onyango"}
                                {isVerified(user?.uid, user?.email) && (
                                    <VerificationBadge
                                        type={getBadgeType(user?.uid, user?.email) || "blue"}
                                        size="sm"
                                    />
                                )}
                            </h4>
                            <span className="handle">{usernameHandle}</span>
                            {isSuperAdmin && (
                                <span className="super-admin-pill">
                                    ⚡ Super Administrator
                                </span>
                            )}
                        </div>
                    </div>

                    {profileMenuOpen && (
                        <ProfileDropdownMenu>
                            <Link to="/fellows" onClick={() => setProfileMenuOpen(false)}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                                </svg>
                                My Profile
                            </Link>
                            <Link to="/home" onClick={() => setProfileMenuOpen(false)}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                                </svg>
                                My Posts & Questions
                            </Link>
                            <Link to="/fellows" onClick={() => setProfileMenuOpen(false)}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                                </svg>
                                My Communities
                            </Link>
                            <Link to="/profile" onClick={() => setProfileMenuOpen(false)} className="profile-link">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                                </svg>
                                My Profile
                            </Link>
                            {isSuperAdmin && (
                                <Link to="/admin" onClick={() => setProfileMenuOpen(false)} className="admin-link">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 4l5 2.18V11c0 3.5-2.33 6.79-5 7.93C9.33 17.79 7 14.5 7 11V7.18L12 5z"/>
                                    </svg>
                                    Admin Panel
                                </Link>
                            )}
                            {!isVerified(user?.uid, user?.email) && (
                                <button
                                    className="request-verify-btn"
                                    onClick={() => { setShowVerifyModal(true); setProfileMenuOpen(false); }}
                                >
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 13l-3-3 1.4-1.4L10 11.2l5.6-5.6L17 7l-7 7z"/>
                                    </svg>
                                    Request Verification
                                </button>
                            )}
                            <div className="menu-divider" />
                            <button onClick={handleSignOut} className="logout-btn">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
                                </svg>
                                Logout
                            </button>
                        </ProfileDropdownMenu>
                    )}
                </UserProfileCard>

                <div className="footer">
                    <p> {`${`About . `}`}</p>
                    <p> Careers . </p>
                    <p> Terms . </p>
                    <p> Privacy . </p>
                    <p> Business . </p>
                </div>
            </div>
        </Space>

        {showVerifyModal && (
            <RequestVerification onClose={() => setShowVerifyModal(false)} />
        )}
        </>
    );
};

const Space = styled.div`
    width: 16rem;
    flex-shrink: 0;
    position: sticky;
    top: 70px;
    height: fit-content;
    max-height: calc(100vh - 90px);
    overflow-y: auto;
    color: #636466;
    font-size: 16px;

    .create-space-container {
        width: 100%;
        background-color: #ffffff !important;
        border: 1px solid rgba(201, 160, 99, 0.25);
        border-radius: 8px;
        padding: 0.5rem 0.4rem;
        box-shadow: 0 4px 20px rgba(10, 20, 40, 0.06);
    }

    &:hover {
        overflow-y: visible;
    }
    border-top: 1px solid rgba(240, 240, 240, 0.6);
    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: var(--primary-hover-background-color);
        border-radius: 2px;
    }
    .createSpace {
        display: flex;
        min-height: 2.2rem;
        cursor: pointer;
        background-color: rgb(236, 237, 237);
        display: flex;
        align-items: center;
        justify-content: center;
        & > div {
            width: 1.1rem;
            height: 1.1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;

            border-radius: 50%;
            line-height: -50%;
            background-color: rgb(230, 231, 232);

            div {
                transform: translateY(-12%);
            }
        }
        &:hover {
            background: var(--primary-hover-background-color);
        }
        p {
            cursor: pointer;
        }
    }
    .my-communities {
        padding: 0.4rem 0.3rem;
        border-bottom: 1px solid rgba(201, 160, 99, 0.2);
        margin-bottom: 0.4rem;

        .label {
            font-size: 14px;
            font-weight: 700;
            color: #999;
            text-transform: uppercase;
            letter-spacing: 0.4px;
            padding: 0 0.4rem;
        }

        .none {
            font-size: 15px;
            color: #aaa;
            font-style: italic;
            padding: 0.3rem 0.4rem;
        }

        .my-comm {
            display: flex;
            align-items: center;
            gap: 9px;
            padding: 0.4rem 0.5rem;
            text-decoration: none;
            color: #333;
            font-size: 16px;
            border-radius: 6px;

            &:hover {
                background: #faf7f2;
                color: #1DA1F2;
            }

            img {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                object-fit: cover;
            }

            .init {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                background: linear-gradient(135deg, #c9a063, #e8c47d);
                color: white;
                font-weight: 700;
                font-size: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
            }
        }
    }

    .discoverSpace {
        padding-left: 0.54rem;
        padding-top: 0.3rem;
        display: flex;
        min-height: 2.2rem;
        margin-bottom: 2rem;
        cursor: pointer;
        &:hover {
            background: var(--primary-hover-background-color);
        }
        span {
            width: 1.2rem;
            height: 1.4rem;
            margin-right: 10px;
            padding-top: 4px;
            padding-bottom: 0px !important;
            padding-left: 3px;
            border-radius: 0.9rem;
            background-color: rgb(230, 231, 232);
        }
        p {
            padding-left: 0.4rem;
            cursor: pointer;
        }
    }
    }
`;

const FellowsCard = styled.div`
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding: 0.85rem 0.75rem;
    background: linear-gradient(145deg, #ffffff 0%, #faf7f2 100%);
    border: 1px solid rgba(201, 160, 99, 0.35);
    border-radius: 10px;
    box-shadow: 0 4px 15px rgba(10, 20, 40, 0.04);

    .card-header {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #0a1428;
        font-size: 21px;
        margin-bottom: 6px;

        .icon-badge {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: linear-gradient(135deg, #1DA1F2, #0d8ecf);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 6px rgba(29, 161, 242, 0.3);
        }
    }

    .online-count {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 18px;
        color: #15803d;
        font-weight: 700;
        margin-bottom: 6px;

        .live-pulse {
            width: 9px;
            height: 9px;
            background-color: #22c55e;
            border-radius: 50%;
            display: inline-block;
            box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
            animation: pulse-green 2s infinite;
        }

        @keyframes pulse-green {
            0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7); }
            70% { transform: scale(1); box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }
            100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
        }
    }

    p {
        font-size: 18px;
        color: #555;
        line-height: 1.35;
        margin-bottom: 10px;
    }

    .discover-btn {
        width: 100%;
        padding: 6px 12px;
        background: linear-gradient(135deg, #1DA1F2 0%, #0d8ecf 100%);
        color: white;
        border: none;
        border-radius: 16px;
        font-size: 19px;
        font-weight: 700;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        box-shadow: 0 2px 8px rgba(29, 161, 242, 0.25);
        transition: transform 0.15s, box-shadow 0.15s;

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(29, 161, 242, 0.4);
        }
    }
`;

const UserProfileCard = styled.div`
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    border-top: 1px solid rgba(201, 160, 99, 0.25);
    padding-top: 0.75rem;
    position: relative;

    .user-profile-header {
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        padding: 6px;
        border-radius: 8px;
        transition: background 0.15s;

        &:hover {
            background-color: #faf7f2;
        }

        .avatar-ring {
            position: relative;
            width: 40px;
            height: 40px;
            flex-shrink: 0;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                object-fit: cover;
                border: 2px solid #c9a063;
            }

            .online-badge {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 10px;
                height: 10px;
                background-color: #22c55e;
                border: 2px solid white;
                border-radius: 50%;
            }
        }

        .user-info {
            display: flex;
            flex-direction: column;

            h4 {
                font-size: 21px;
                color: #0a1428;
                font-weight: 700;
                margin: 0;
                line-height: 1.1;
            }

            .handle {
                font-size: 18px;
                color: #1DA1F2;
                font-weight: 600;
            }

            .super-admin-pill {
                display: inline-flex;
                align-items: center;
                gap: 4px;
                font-size: 15px;
                font-weight: 700;
                color: #ffffff;
                background: linear-gradient(135deg, #7c3aed, #a855f7);
                border-radius: 10px;
                padding: 2px 8px;
                margin-top: 3px;
            }

            .verified-pill {
                display: inline-flex;
                align-items: center;
                gap: 4px;
                font-size: 15px;
                font-weight: 700;
                color: #1DA1F2;
                margin-top: 1px;
            }
        }
    }
`

const ProfileDropdownMenu = styled.div`
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    border: 1px solid rgba(201, 160, 99, 0.35);
    border-radius: 10px;
    box-shadow: 0 8px 25px rgba(10, 20, 40, 0.12);
    padding: 6px 0;
    z-index: 100;
    margin-bottom: 8px;

    a, button {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        padding: 8px 12px;
        text-align: left;
        font-size: 19px;
        font-weight: 600;
        color: #333;
        text-decoration: none;
        background: none;
        border: none;
        cursor: pointer;
        transition: background 0.15s, color 0.15s;

        &:hover {
            background-color: #faf7f2;
            color: #1DA1F2;
        }

        svg {
            color: #1DA1F2;
            flex-shrink: 0;
        }
    }

    .menu-divider {
        height: 1px;
        background-color: rgba(201, 160, 99, 0.2);
        margin: 4px 0;
    }

    .logout-btn {
        color: #d32f2f;

        svg {
            color: #d32f2f;
        }

        &:hover {
            color: #d32f2f;
            background-color: #ffebee;
        }
    }

    .admin-link {
        color: #7c3aed;
        font-weight: 700;

        svg {
            color: #7c3aed;
        }

        &:hover {
            background-color: #f3f0ff;
            color: #7c3aed;
        }
    }

    .profile-link {
        color: #1DA1F2;
        font-weight: 700;

        svg {
            color: #1DA1F2;
        }

        &:hover {
            background-color: #e8f5fe;
            color: #1DA1F2;
        }
    }

    .request-verify-btn {
        color: #1DA1F2;
        font-weight: 700;

        svg {
            color: #1DA1F2;
        }

        &:hover {
            background-color: #e8f5fe;
            color: #1DA1F2;
        }
    }
`;
